import React, {useState} from "react"
import {Box, Button, Drawer, Grid, List, Typography} from "@mui/material"
import {SouthEast, SouthWest} from "@mui/icons-material"
import NavBarListItem from "./NavBarListItem"
import {useLocation} from 'react-router-dom'
import { iconMap } from "../assets/icons"

const drawerWidthOpen = 240
const drawerWidthClosed = 80

const NavBar = ({links, anchorDirection, defaultOpen = false}) => {
    const [open, setOpen] = useState(defaultOpen)
    const location = useLocation()
    const toggleDrawer = () => {
        setOpen(!open)
    }

    return (
        <Box sx={{display: "flex"}}>
            <Drawer
                variant="permanent"
                anchor={anchorDirection}
                sx={{
                    width: open ? drawerWidthOpen : drawerWidthClosed,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: open ? drawerWidthOpen : drawerWidthClosed,
                        transition: (theme) =>
                            theme.transitions.create("width", {
                                easing: theme.transitions.easing.sharp,
                                duration:
                                    theme.transitions.duration.enteringScreen,
                            }),
                        overflowX: "hidden",
                        border: "none",
                        height: "calc(100% - 160px)",
                        top: "80px",
                        padding: "24px 0 0 0",
                    },
                }}>
                <Grid
                    container
                    justifyContent="space-between"
                    height="100%">
                    <List sx={{width: "100%"}}>
                        {links.map((item) => (
                            <NavBarListItem
                                key={item.id}
                                label={item.displayName}
                                icon={iconMap[item.icon]}
                                open={open}
                                onClick={item.onClick}
                                openInNewPage={item.openInNewPage}
                                isActive={location.pathname === item.path}
                            />
                        ))}
                    </List>

                    <Box
                        width="100%"
                        sx={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: open ? "flex-start" : "center",
                            p: 2,
                        }}>
                        <Button
                            variant="tertiary"
                            onClick={toggleDrawer}
                            sx={{padding: "4px", minWidth: "44px"}}>
                            {open ? (
                                <>
                                {anchorDirection === "left" ? <SouthWest /> : <SouthEast />}
                                    <Typography>Minimieren</Typography>
                                </>
                            ) : (
                                anchorDirection === "left" ? <SouthEast /> : <SouthWest />
                            )}
                        </Button>
                    </Box>
                </Grid>
            </Drawer>
        </Box>
    )
}

export default NavBar
